import { createContext } from 'react';
import type { Office } from '../shared/types';

type Context = {
  offices: Array<Office>;
  displayManualEmailEntry: boolean;
};

const defaultContext = {
  offices: [],
  displayManualEmailEntry: false,
} as const;

// @ts-expect-error - TS2345 - Argument of type '{ readonly offices: readonly []; readonly displayManualEmailEntry: false; }' is not assignable to parameter of type 'Context'.
export const MultipleRulesContext = createContext<Context>(defaultContext);
